import React from 'react'

const VipEventFormSuccess = ({data}) => {
  const {preferredDay, preferredTime} = data;
  return (
    <div className='service-form__success alert alert-success my-4'>
        <h3 className='text-center'>Thank you for registering!</h3>
        <p className='text-center'>We have received your registration and look forward to seeing you on: {preferredDay}, {preferredTime}.</p>
    </div>
  )
}

export default VipEventFormSuccess